import React from "react";
import AndroidRoutine from "./AndroidRoutine";

const AndroidRoutineList = ({ routines, isLrVideo, androidBtn }) => {
  return (
    <div className="row" style={{ backgroundColor: "black" }}>
      {routines.map((routine, i) => (
        <AndroidRoutine
          key={routine._id}
          routine={routine}
          routineCount={routines.length}
          isLrVideo={isLrVideo}
          androidBtn={androidBtn}
        ></AndroidRoutine>
      ))}
    </div>
  );
};

export default AndroidRoutineList;
